import React from 'react';

const TotalTr = ({ totals = {}, profileType = '' }) => {
  const {
    extraShareTotals = 0,
    adminShareTotals = 0,
    contractValueTotals = 0,
  } = totals;

  return (
    <tr className="summary-tr">
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
    </tr>
  );
};

export default TotalTr;
